import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import * as Dropdown from 'components/Dropdown';

const ParameterDropdownComponent = ({ label, ...props }) => (
  <div className="main-dropdown mb-20">
    <p className="main-dropdown__label">
      {label}
    </p>

    <Field
      {...props}
      placeholder="Select a Variable"
      component={Dropdown.ReduxFormWrapper}
      noOptionsMessage={() => 'Select more parameters to perform this type of calculations!'}
    />
  </div>
);

ParameterDropdownComponent.propTypes = {
  label: PropTypes.string.isRequired
};

export default ParameterDropdownComponent;
